import { createFileRoute } from "@tanstack/react-router"

import { DesktopAccountDetail } from "@/crm/components/account-detail/desktop/detail"
import { MobileAccountDetail } from "@/crm/components/account-detail/mobile/detail"
import { Adaptive } from "@/crm/lib/viewport"

type AccountDetailSearch = { tab?: "overview" | "timeline" | "contacts" | "conversions" }

export const Route = createFileRoute("/_crm/accounts/$id")({
  component: AccountDetailRoute,
  validateSearch: (search: Record<string, unknown>): AccountDetailSearch => ({
    tab: typeof search.tab === "string" ? (search.tab as AccountDetailSearch["tab"]) : undefined,
  }),
})

function AccountDetailRoute() {
  const { id } = Route.useParams()
  const { tab } = Route.useSearch()
  return (
    <Adaptive
      desktop={<DesktopAccountDetail accountId={id} initialTab={tab} />}
      mobile={<MobileAccountDetail accountId={id} initialTab={tab} />}
    />
  )
}
